import React from 'react';
import PropTypes from 'prop-types';
import { withLocalize } from 'react-localize-redux';
import Icon, { IconSizes, IconTypes } from '../../components/foundations/Icon';
import ChatInput from './ChatInput';
import SingularLogo from '../../resources/svg/singular_logo_blue_figma.svg';
import { AI_PROMPT_SUGGESTIONS_PREFIX, AI_PROMPT_SUGGESTION_IDS } from '../aiPromptSuggestions';
import css from './ChatEmptyState.css';

const TRANSLATION_PREFIX = 'STATIC.PAGES.ANALYSIS_CHAT.EMPTY_STATE';

const SUGGESTION_ICONS = {
    COMPARE_PERFORMANCE: 'chart-bar',
    SUMMARIZE_ACTIVITY: 'file-text-spark',
    EXPLAIN_DECREASE: 'chart-histogram',
    BUILD_DASHBOARD: 'layout-dashboard',
};
const SUGGESTION_ICON_COLOR = 'var(--blue300)';

const SUGGESTIONS = AI_PROMPT_SUGGESTION_IDS.map(id => ({
    id,
    icon: SUGGESTION_ICONS[id],
    iconColor: SUGGESTION_ICON_COLOR,
}));

const ChatEmptyState = ({
    onSuggestionClick,
    input,
    handleInputChange,
    handleSubmit,
    isLoading,
    stop,
    onMicClick,
    isMicListening,
    micSupported,
    translate,
}) => {
    return (
        <div className={css.chatEmptyState}>
            <div className={css.greetingSection}>
                <SingularLogo className={css.greetingLogo} />
                <div className={css.greetingTitle}>{translate(`${TRANSLATION_PREFIX}.GREETING_TITLE`)}</div>
            </div>

            <div className={css.chatInputWrapper}>
                <ChatInput
                    input={input}
                    handleInputChange={handleInputChange}
                    handleSubmit={handleSubmit}
                    isLoading={isLoading}
                    stop={stop}
                    onMicClick={onMicClick}
                    isMicListening={isMicListening}
                    micSupported={micSupported}
                    containerClassName={css.chatInputInEmptyState}
                />
            </div>

            <div className={css.suggestionsGrid}>
                {SUGGESTIONS.map(({ id, icon, iconColor }) => {
                    const query = translate(`${AI_PROMPT_SUGGESTIONS_PREFIX}.${id}`);
                    return (
                        <button
                            type="button"
                            key={id}
                            onClick={() => onSuggestionClick(query)}
                            className={css.suggestionCard}
                        >
                            <Icon
                                name={icon}
                                type={IconTypes.TABLER}
                                size={IconSizes.SMALL}
                                style={{ color: iconColor }}
                            />
                            <div className={css.suggestionText}>{query}</div>
                        </button>
                    );
                })}
            </div>
        </div>
    );
};

ChatEmptyState.propTypes = {
    onSuggestionClick: PropTypes.func.isRequired,
    input: PropTypes.string.isRequired,
    handleInputChange: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    isLoading: PropTypes.bool.isRequired,
    stop: PropTypes.func.isRequired,
    onMicClick: PropTypes.func,
    isMicListening: PropTypes.bool,
    micSupported: PropTypes.bool,
    translate: PropTypes.func.isRequired,
};

export default withLocalize(ChatEmptyState);
